var app = app || {};
(function ($) {
    app.UserNotificationHelper = (function () {
        return function () {

            /* Message Extracting based on Notification Data Type ********/

            //add your custom notification data types here...

            /* Example:
            abp.notifications.messageFormatters['ByteDash.BankBot.MyNotificationDataType'] = function(userNotification) {
                return ...; //format and return message here
            };
            */

            var _notificationService = abp.services.app.notification;

            /* Converter functions ***************************************/

            function getUrl(userNotification) {
                switch (userNotification.notification.notificationName) {
                    case "App.NewUserRegistered":
                        return `/App/users?filterText=${userNotification.notification.data.properties.emailAddress}`;
                    case "App.NewTenantRegistered":
                        return `/App/tenants?filterText=${userNotification.notification.data.properties.tenancyName}`;
                    case "App.GdprDataPrepared":
                        return `/File/DownloadBinaryFile?id=${userNotification.notification.data.properties.binaryObjectId}&contentType=application/zip&fileName=collectedData.zip`;
                    case "App.DownloadInvalidImportUsers":
                        return `/File/DownloadTempFile?fileToken=${userNotification.notification.data.properties.fileToken}&fileType=${userNotification.notification.data.properties.fileType}&fileName=${userNotification.notification.data.properties.fileName}`;
                        //Add your custom notification names to navigate to a URL when user clicks to a notification.
                }

                if (userNotification.notification.data.properties.url) {
                    return userNotification.notification.data.properties.url;
                }

                //No url for this notification
                return "";
            };

            /* PUBLIC functions ******************************************/

            var format = function (userNotification, truncateText) {
                const formatted = {
                    userNotificationId: userNotification.id,
                    text: abp.notifications.getFormattedMessageFromUserNotification(userNotification),
                    dateTime: new Date(userNotification.notification.creationTime),
                    formattedDateTime: app.utils.dateTime.formatLong2DateShortTime(userNotification.notification.creationTime),
                    icon: app.notification.getUiIconBySeverity(userNotification.notification.severity),
                    state: userNotification.state,
                    data: userNotification.notification.data,
                    url: getUrl(userNotification),
                    isUnread: userNotification.state === abp.notifications.userNotificationState.UNREAD,
                    timeAgo: window.moment(userNotification.notification.creationTime).fromNow(),
                    iconFontClass: app.notification.getIconFontClassBySeverity(userNotification.notification.severity),
                    severity: userNotification.notification.severity,
                    severityText: app.notification.getTextBySeverity(userNotification.notification.severity)
                };

                if (truncateText || truncateText === undefined) {
                    formatted.text = abp.utils.truncateStringWithPostfix(formatted.text, app.consts.notification.textCharacterLimit);
                }
                
                return formatted;
            };

            const show = function (userNotification) {
                //Application notification
                abp.notifications.showUiNotifyForUserNotification(userNotification, {
                    'onclick': function () {
                        //Take action when user clicks to live toastr notification
                        const url = getUrl(userNotification);
                        if (url) {
                            location.href = url;
                        }
                    }
                });

                //Desktop notification
                window.Push.create(abp.setting.get("AppSettings.App.Name"), {
                    body: format(userNotification).text,
                    icon: `${abp.appPath}TenantCustomization/GetTenantSecondaryLogo/dark/${app.session.tenant.id}?maintainCompatibility=true`,
                    timeout: 0,
                    onClick: function () {
                        window.focus();
                        this.close();
                    }
                });

                const audio = new Audio(`${abp.appPath}Common/Audio/Notification.mp3`);
                audio.play();
            };

            const setAllAsRead = function (callback) {
                return _notificationService.setAllNotificationsAsRead().done(function () {
                    abp.event.trigger("app.notifications.refresh");
                    callback && callback();
                });
            };

            const setAsRead = function (userNotificationId, callback) {
                return _notificationService.setNotificationAsRead({
                    id: userNotificationId
                }).done(function () {
                    abp.event.trigger("app.notifications.read", userNotificationId);
                    callback && callback(userNotificationId);
                });
            };

            const openSettingsModal = function () {
                new app.ModalManager({
                    viewUrl: `${abp.appPath}App/Notifications/SettingsModal`,
                    scriptUrls: `${abp.appPath}view-resources/Areas/App/Views/Notifications/_SettingsModal.min.js`,
                    modalClass: "NotificationSettingsModal"
                }).open();
            };

            /* Expose public API *****************************************/

            return {
                format: format,
                show: show,
                setAllAsRead: setAllAsRead,
                setAsRead: setAsRead,
                openSettingsModal: openSettingsModal
            };
        };
    })();
})(jQuery);
